{
  "version": 1,
  "asset_id": "1895e3af-6114-439e-a701-f3e86b9f737c",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/1895e3af-6114-439e-a701-f3e86b9f737c/clip-img_2224.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/1895e3af-6114-439e-a701-f3e86b9f737c/clip-img_2224.mp4",
  "original_filename": "clip-img_2224.mp4",
  "size": 259751,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:58Z"
}
